import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import SEO from "../../../../utils/SEO";

const TIMELINE_STYLE = { background: "#EFF6FF", border: "#DBEAFE" };

export default function GamingLicenseAnjouan () {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.gaming-license-anjouan.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/gaming-license-anjouan"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/contact"
                imageSrc={require("../../../../assets/images/services/gaming-license-anjouan-hero.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ subtitle: tp('why.blockSubtitle'), items: obj('why.items') }]}
                    />

                    <FeatureCards
                        title={tp('covers.title')}
                        subtitle={tp('covers.subtitle')}
                        features={obj('covers.items')}
                    />

                    <LocationTimeline
                        title={tp('benefits.title')}
                        item={obj('benefits.items')}
                    />

                    {/* Services */}
                    <ServiceCards
                        title={tp('process.title')}
                        services={obj('process.items')}
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title={tp('timeline.title')}
                        items={(obj('timeline.items') || []).map((item) => ({ ...item, ...TIMELINE_STYLE }))}
                    />

                    <DetailsSection
                        title={tp('whyUs.title')}
                        items={obj('whyUs.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    {/* Final CTA */}
                    <CTA title={tp('cta.title')}
                         description={tp('cta.description')}
                         buttonText={tp('cta.button')}
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};
